/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useCallback, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../../../components/TextInputV2'
import {Selection} from '../../../../../components/Selection'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {filterSelector, setFilterMasterPricing} from '../../../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../../../components/Table/Table'
import { useSalesOrganization } from 'src/hooks/useSalesOrganization'
import DatePickerV2 from 'src/components/DatePickerV2/DatePickerV2'

export const RowFilter = memo((props: any) => {
  const {mode} = props
  const {t} = useTranslation()
  const {filterMasterPricing: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization(true)

  const statusOptions = [
    {label: 'Active', value: 'true'},
    {label: 'Inactive', value: 'false'},
  ]
  const isJbpOptions = [
    {label: 'Prioritas', value: 'true'},
    {label: 'Basic', value: 'false'},
  ]

  const handleChange = useCallback(
    (value: Partial<typeof filter>) => {
      dispatch(setFilterMasterPricing({...filter, ...value}))
    },

    [filter]
  )

  useEffect(() => {
    let _filter = filter
    try{
      let storage = localStorage.getItem('redux-master-pricing-filter') as string
      if(storage) {
        let persisted = JSON.parse(storage)
        _filter = {
          ...filter,
          ...persisted
        }
        dispatch(setFilterMasterPricing(_filter))
      }

    }catch(e){
      console.log(e)
    }
  }, [])

  return (
    <TRowFilter>
      <td>&nbsp;</td>
      <td>
        <Selection
          data={salesOrgOptions}
          placeholder={t('sub-order-produsen')}
          value={filter?.company_code ?? ''}
          onChange={(sales_org_code) => handleChange({company_code: sales_org_code})}
        />
      </td>
      { mode == 'jbp-type-pricing' && <>
        <td>
          <TextInputV2
            placeholder={t('jbp-type-code')}
            value={filter?.jbp_type_code ?? ''}
            onChange={({target}) => handleChange({jbp_type_code: target.value})}
          />
        </td>
        <td>
          <TextInputV2
            placeholder={t('jbp-type')}
            value={filter?.jbp_type_desc ?? ''}
            onChange={({target}) => handleChange({jbp_type_desc: target.value})}
          />
        </td>
      </>
      }
      {
        mode != 'jbp-type-pricing' && <td>
            <Selection
            data={isJbpOptions}
            placeholder={'Status'}
            value={filter?.is_jbp ?? ''}
            onChange={(is_jbp) => handleChange({is_jbp})}
          />
        </td>
      }
      <td>
        <TextInputV2
          placeholder={t('Plant Code')}
          value={filter?.plant_code ?? ''}
          onChange={({target}) => handleChange({plant_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sub-order-gudang')}
          value={filter?.plant_desc ?? ''}
          onChange={({target}) => handleChange({plant_desc: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('incoterm')}
          value={filter?.incoterm ?? ''}
          onChange={({target}) => handleChange({incoterm: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Product Code')}
          value={filter?.product_code ?? ''}
          onChange={({target}) => handleChange({product_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Material Product')}
          value={filter?.product_desc ?? ''}
          onChange={({target}) => handleChange({product_desc: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-hargaPPN')}
          value={filter?.price ?? ''}
          onChange={({target}) => handleChange({price: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('valid date')}
          isSelectsRange={false}
          startDate={filter?.valid_from ?? ''}
          onChange={({startDate}) => handleChange({valid_from: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('valid to')}
          isSelectsRange={false}
          startDate={filter?.valid_to ?? ''}
          onChange={({startDate}) => handleChange({valid_to: startDate})}
        />
      </td>
      <td>
      <Selection
          data={statusOptions}
          placeholder={'Status'}
          value={filter?.is_active ?? ''}
          onChange={(is_active) => handleChange({is_active})}
        />
      </td>
      <td>&nbsp;</td>
    </TRowFilter>
  )
})
